<template>
    <v-card :loading="loading">
        <v-tabs color="primary" fixed-tabs v-model="tab">
            <v-tab v-for="tab of tabs" :value="tab.label">
                <v-icon :icon="tab.icon"></v-icon>
                {{ tab.label }}</v-tab>
        </v-tabs>
        <v-card-text>
            <v-tabs-window v-model="tab">

                <v-tabs-window-item v-for="tab of tabs" :value="tab.label">
                    <v-data-table :headers="headers" :items="filteredItems(tab.label)" class="elevation-1">
                        <template v-slot:item.name="{ item }">
                            <div class="text-left">
                                {{ item.name }}
                            </div>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                            {{ getFormattedDate(item.createdAt) }}
                        </template>

                        <template v-slot:item.size="{ item }">
                            {{ formatSize(item.size) }}
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-btn variant="text" icon="mdi-download" @click="download(item)"></v-btn>
                            <v-btn variant="text" color="red" @click="dialogToDelete = true; csvToDelete = item"
                                icon="mdi-delete"></v-btn>
                        </template>
                    </v-data-table>
                </v-tabs-window-item>

            </v-tabs-window>
        </v-card-text>

    </v-card>
    <v-dialog v-model="dialogToDelete">
        <ConfirmForm :text="'Do you want to delete the CSV file named ' + csvToDelete.name" location="top"
            style="justify-content:center;align-items: center;" @close="dialogToDelete = false" @confirm="deleteCsv"
            type-to-delete="CSV File"></ConfirmForm>
    </v-dialog>

</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCsvStore } from '@/store/csvStore';
import { ref, computed } from 'vue';
import { api_url } from '@/config/api_url';
import ConfirmForm from '../forms/ConfirmForm.vue';
import { useNotificationStore } from '@/store/notificationStore';


const notificationStore = useNotificationStore();
const csvStore = useCsvStore();
const { loading, csvs } = storeToRefs(csvStore);
const tab = ref(null);
const dialogToDelete = ref(false);
const csvToDelete = ref();
const headers = [
    { title: 'Name', value: 'name', align: 'start' },
    { title: 'Created At', value: 'createdAt', align: 'center' },
    { title: 'Size', value: 'size', align: 'center' },
    { title: 'Actions', value: 'actions', sortable: false }
];
const tabs = [
    { label: "Imported files", icon: "mdi-file-upload" },
    { label: "Exported files", icon: "mdi-file-download" }
];

const deleteCsv = async () => {
    const keyPath = tab.value === 'Imported files' ? 'uploadsCSV' : 'exportsCSV';
    await csvStore.deleteFile(keyPath, csvToDelete.value.name);
    dialogToDelete.value = false;

}

const formatSize = (size) => {
    if (size < 1024) return size + ' B';
    if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
    if (size < 1024 * 1024 * 1024) return (size / (1024 * 1024)).toFixed(1) + ' MB';
    return (size / (1024 * 1024 * 1024)).toFixed(1) + ' GB';
};

function filteredItems(tabLabel) {
    const key = tabLabel === 'Imported files' ? 'uploadFiles' : 'exportFiles';
    return [...(csvs.value?.[key] || [])].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
}

const download = (file) => {
    const keyPath = tab.value === 'Imported files' ? 'uploadsCSV' : 'exportsCSV';
    try {
        const fileUrl = api_url + "/" + keyPath + "/" + file.name;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileUrl.split('/').pop();
        link.click();
    } catch (e) {
        console.log(e);
    }

}


const getFormattedDate = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
} 
</script>